if (!customElements.get('our-range-card-copy')) {
  class OurRangeCardCopy extends HTMLElement {
    connectedCallback() {
      this.description = this.querySelector('.our-range-card__description');
      this.button = this.querySelector('.our-range-card__read-more');

      if (!this.description || !this.button) return;

      this.readMoreLabel = this.button.dataset.readMore;
      this.readLessLabel = this.button.dataset.readLess;

      this.checkTruncation();
      this.button.addEventListener('click', this.toggle.bind(this));

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => this.checkTruncation());
        this.resizeObserver.observe(this.description);
      } else {
        window.addEventListener('resize', this.checkTruncation.bind(this));
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    checkTruncation() {
      if (this.button.getAttribute('aria-expanded') === 'true') return;

      this.description.classList.remove('is-expanded');

      const isTruncated =
        this.description.scrollHeight > this.description.clientHeight + 1;

      this.button.hidden = !isTruncated;
    }

    toggle() {
      const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
      const nextExpanded = !isExpanded;

      this.button.setAttribute('aria-expanded', String(nextExpanded));
      this.description.classList.toggle('is-expanded', nextExpanded);
      this.button.textContent = nextExpanded
        ? this.readLessLabel
        : this.readMoreLabel;
    }
  }

  customElements.define('our-range-card-copy', OurRangeCardCopy);
}
